export enum enumTodoStatus {
  Active= 1,
  Cancelled,
  Completed
}

export namespace enumTodoStatus {
  export function values() {
    return Object.keys(enumTodoStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
